// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"styles_tabsWrapper__2VeOi","tab":"styles_tab__17TFw","activeTab":"styles_activeTab__1aLQQ"};